import { Injectable } from '@angular/core';
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
@Injectable({
	providedIn: 'root'
})
export class NotificationService extends DMSBaseService {
	constructor(public provider: ServiceProvider) {
		super('/notifications', provider);
	}

	public fetchUnreadMessage() {
		return this.getList(`/all`);
	}

	public markConversationRead(conversationId) {
		return this.update(null,`/read/${conversationId}`);
	}

	public markConversationReadAll() {
		return this.update(null,`/read/all`);
	}
	
}
